<app-template-a *ngIf="ulrAcp==0"></app-template-a>
<app-template-acp *ngIf="ulrAcp==1"></app-template-acp>